import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Icon from "core/icon/Icon";
import StepHeader from "./StepHeader";

// Step 1 — the week kicker. The carousel cells moved to WeekStrip, above the
// card and visible at every step; only the title and the two warnings (nothing
// to declare / draft in progress) remain here. No call: `commitCurrentStep`
// returns true for this step.
//
// The window spans [current − 2 … current + 2], so two future weeks are always
// on screen. The client states they are declarable; nothing here dims them for
// that reason. Actually opening one is a back-side change though: the front
// never names a week — POST /datatrack/declaration carries the form alone and
// the back picks which week it lands on — and this step assumes a single OPEN
// cell (findOpenWeek).
const WeekStep = ({ upToDate, openWeekStart, blockedByDraft }) => {
  const caughtUp = upToDate || !openWeekStart;

  return (
    <div className="faf-step faf-step--intro">
      <StepHeader>
        {caughtUp ? (
          <FormattedMessage
            id="tools_manager_faf_week_title_up_to_date"
            defaultMessage="Aucune semaine à déclarer"
          />
        ) : blockedByDraft ? (
          <FormattedMessage
            id="tools_manager_faf_week_title_finish_draft"
            defaultMessage="Termine ta déclaration en cours"
          />
        ) : (
          <FormattedMessage
            id="tools_manager_faf_week_title_current"
            defaultMessage="Déclare ta semaine"
          />
        )}
      </StepHeader>

      {caughtUp && (
        <div className="faf-week-uptodate">
          <Icon icon="tick-gray" color="green" width={20} height={20} />
          <FormattedMessage
            id="tools_manager_faf_week_up_to_date_desc"
            defaultMessage="Toutes tes semaines passées ainsi que la semaine en cours sont déclarées."
          />
        </div>
      )}

      {!caughtUp && blockedByDraft && (
        <div className="faf-week-notice">
          <Icon icon="warning" color="gamboge" width={16} height={16} />
          <FormattedMessage
            id="tools_manager_faf_week_finish_draft_first"
            defaultMessage="Reprends et termine ta déclaration en cours avant d'en commencer une nouvelle."
          />
        </div>
      )}

      {/* The five weeks now live in the strip at the top, present at every
          step: repeating them here would duplicate the same information. */}
    </div>
  );
};

WeekStep.propTypes = {
  upToDate: PropTypes.bool,
  openWeekStart: PropTypes.string,
  blockedByDraft: PropTypes.bool,
};

export default WeekStep;
